import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router";
import { withRouter } from "../common/with-router";
import ReportService from "../services/report.service"

const ReportsSessionsSignups = () => {
  const sessionDate = useOutletContext();
  const [signups, setSignups] = useState(undefined);

  useEffect(() => {
    ReportService.listSignups(sessionDate)
    .then(resp => {
      setSignups(convertSignupsToTable(resp.data.signups));
    })
    .catch(handleError);
  }, [sessionDate]);

  const handleError = e => {
    if (e.response?.status === 403) {
      this.props.router.navigate("/login");
    }
  };

  const convertSignupsToTable = signups => {
    if (signups.length === 0) {
      return [];
    }
    const table = [];
    const total = {name: null, tutors: 0, students: 0};
    var row = null;
    for (const signup of signups) {
      const name = signup.name;
      if ((row === null) || (name !== row.name)) {
        if (row !== null) {
          total.tutors += row.tutors;
          total.students += row.students;
          table.push(row);
        }
        row = {name: signup.name, tutors: 0, students: 0};
      }
      if (signup.role === "Manager" || signup.role === "Tutor") {
        row.tutors += signup.count;
      } else {
        row.students += signup.count;
      }
    }
    total.tutors += row.tutors;
    total.students += row.students;
    table.push(row);
    table.push(total);
    return table;
  };

  return (
    <div className="mb-3 table-responsive">
      <table className="table table-striped has-totals">
        <thead>
          <tr>
            <th>Branch</th>
            <th className="text-center">Tutors</th>
            <th className="text-center">Students</th>
            <th className="text-center">Total</th>
          </tr>
        </thead>
        <tbody>
          {signups === null && (
            <tr>
              <td colSpan="4">Loading...</td>
            </tr>
          )}
          {signups?.length === 0 && (
            <tr>
              <td colSpan="4">No signups</td>
            </tr>
          )}
          {signups?.map((signup, index) => (
            <tr key={index}>
              <td>{signup.name === null ? "Total" : signup.name}</td>
              <td className="text-center">{signup.tutors}</td>
              <td className="text-center">{signup.students}</td>
              <td className="text-center">{signup.tutors + signup.students}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default withRouter(ReportsSessionsSignups);